import { TextField } from '@mui/material';
import * as React from 'react';

export class SafeUrlGenerator extends React.Component<{}, { forwardTo: string }>{

  state = {
    forwardTo: ""
  };

  render() {
    return (
      <div>
        <TextField fullWidth={true} label="Forward To" onChange={(e) => {
          this.setState({ forwardTo: e.target.value });
        }} slotProps={{
          inputLabel: {shrink: true}
        }} />
        <div style={{height: 8}}></div>
        <TextField fullWidth={true} label="Safe URL" value={this.state.forwardTo?`https://formscatcher.webdrvn.com/send-secure-message/${window.btoa(this.state.forwardTo)}`:''} slotProps={{
          inputLabel: {shrink: true}
        }} />
      </div>
    );
  }
}